// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"32":"d8bf9e12","321":"20f140c7","804":"2004d69c"}[chunkId] + ".js";
};